import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

type CompanyLite = { id: number; name: string };

export default function CompanySwitcher() {
  const { user } = useAuth();
  const [companies, setCompanies] = useState<CompanyLite[]>([]);
  const [activeId, setActiveId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem('activeCompanyId');
      setActiveId(saved);
    } catch {}
    (async () => {
      try {
        const res = await api.get('/companies/list_for_switch/');
        setCompanies(res.data || []);
      } catch (e: any) {
        setError('Unable to load companies');
      }
    })();
  }, []);

  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newId = e.target.value || '';
    setActiveId(newId);
    try {
      if (newId) {
        window.localStorage.setItem('activeCompanyId', newId);
      } else {
        window.localStorage.removeItem('activeCompanyId');
      }
      // Optionally reload to ensure context switch applies everywhere
      window.location.reload();
    } catch {}
  };

  if (error) return <span style={{ color: 'red' }}>{error}</span>;
  if (!companies.length) return null;

  return (
    <select 
      value={activeId || ''} 
      onChange={onChange} 
      style={{ 
        padding: '4px 8px', 
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        borderRadius: '4px',
        color: 'white',
        cursor: 'pointer',
        fontSize: '0.875rem'
      }}
    >
      <option value="" style={{ backgroundColor: '#333' }}>
        {user?.company?.name ? `Your company (${user.company.name})` : 'Your company'}
      </option>
      {companies.map(c => (
        <option key={c.id} value={String(c.id)} style={{ backgroundColor: '#333' }}>{c.name}</option>
      ))}
    </select>
  );
}


